


























import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";

export interface JobsearchReferralSearchParams {
  referrer_name?: string;
  referred_name?: string;
  phone_number?: string;
}

@Component({
  components: {
    AppTextField,
  },
})
export default class extends Vue {
  private referrer_name = "";
  private referred_name = "";
  private phone_number = "";

  @Emit()
  private search(): JobsearchReferralSearchParams {
    const params: JobsearchReferralSearchParams = {
      referrer_name: this.referrer_name,
      referred_name: this.referred_name,
      phone_number: this.phone_number,
    };
    return params;
  }

  private clear(): void {
    this.referrer_name = "";
    this.referred_name = "";
    this.phone_number = "";
    this.search();
  }
}
